import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';


@Injectable()
export class BarcodeScannerProvider {

  constructor() {

  }

  barkodOku() {
    return new Promise((res, err) => {
     var barcodeScanner = new BarcodeScanner();
     barcodeScanner.scan().then((barcodeData) => {
        res(barcodeData);
      }, (err) => {
        err(err);
      });
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/barcode-scanner-provider.ts